import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";

const KEY = "df_welcome_seen";

export function WelcomeScreen() {
  const navigate = useNavigate();
  const [show, setShow] = useState(() => {
    try { return sessionStorage.getItem(KEY) !== "1"; } catch { return true; }
  });

  const dismiss = (cb) => {
    try { sessionStorage.setItem(KEY, "1"); } catch {}
    setShow(false);
    if (cb) setTimeout(cb, 650);
  };
  const viewServices = () => dismiss(() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" }));
  const requestQuote = () => dismiss(() => navigate("/quote"));

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="welcome"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } }}
          className="fixed inset-0 z-[100] bg-cream grain flex items-center justify-center px-6"
          data-testid="welcome-screen"
        >
          <div className="max-w-xl w-full text-center">
            <motion.img
              src="/logo-mark.png" alt="Drunk Fruit Mobile Bar"
              initial={{ opacity: 0, y: 20, scale: 0.96 }} animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1] }}
              className="h-36 sm:h-44 w-auto mx-auto mb-8"
            />
            <motion.h1
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.15 }}
              className="font-serif text-4xl sm:text-5xl leading-[1.05] text-ink"
            >
              Welcome to Drunk Fruit Mobile Bar
            </motion.h1>
            <motion.p
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.3 }}
              className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-lg mx-auto"
            >
              Premium mobile cocktail and mocktail experiences for private events, corporate events,
              weddings, birthdays, baby showers, and celebrations across the GTA and surrounding areas.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.45 }}
              className="mt-9 flex flex-wrap items-center justify-center gap-3"
            >
              <button onClick={requestQuote} className="btn-dark" data-testid="welcome-request-quote">
                Request a Quote <ArrowRight className="h-4 w-4" />
              </button>
              <button onClick={viewServices} className="btn-outline" data-testid="welcome-view-services">
                View Services
              </button>
            </motion.div>
            <motion.p
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8, delay: 0.7 }}
              className="mt-10 text-xs text-muted-foreground/80 max-w-md mx-auto"
            >
              Alcohol is not sold by Drunk Fruit. Clients provide alcohol according to Ontario and venue requirements.
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default WelcomeScreen;
